import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  EParamChannelTypeGlobal,
  ETimeBucketType,
  IReportingAudiencesChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { coreAPI } from '../services/coreAPI'
import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAudiencesReportChartFilters,
  TDOOHAudiencesReportChartFilters,
  TPPAdvertiserId,
} from '../models/types'

export default function useGetAdvertiserReportingAudiencesChartV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  channelType,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TDAAudiencesReportChartFilters | TDOOHAudiencesReportChartFilters) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingAudiencesChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingAudiencesChart_${channelType}_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPI.v2AdvertiserReporting().getAdvertiserAudiencesReportChart(
        advertiserId,
        generateCorrelationId(),
        retailerId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
